export function sortObjbyName(data, type) : any[] {
    let ordered = [];
    let dataArr = [].slice.call(data);
    let dataSorted = dataArr.sort((a, b) => {
        if (type === "asc") {
            if (a.name < b.name) return -1;
            else return 1;
        } else {
            if (a.name > b.name) return -1;
            else return 1;
        }
    });
    dataSorted.forEach(e => ordered.push(e));
    return ordered;
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/functions/sortObjbyName.function.ts